import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/offer';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-155" data-mp="1n00ojw8ieprz">
      <Reveal className="mx-auto max-w-6xl" data-id="element-156" data-mp="1mziun69bknn8">
        <div className="mb-12 text-center" data-id="element-157" data-mp="1r1m5bso5zo7g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-158" data-mp="1r0b4a0m3suk1">LOVED BY EDUCATORS</p>
          <h2 className="text-3xl font-black text-brand-deep md:text-4xl" data-id="element-159" data-mp="1d09utwrrwesy">What Biology Teachers Are Saying.</h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-160" data-mp="1i28uowob0tl5">⭐⭐⭐⭐⭐ Clear science, ready labs, hours saved</p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="182rswqc6azug">
          {testimonials.map(({
          quote,
          name,
          role
        }) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-162" data-mp="2yenwy95jgk6b">
              <div className="flex gap-1" data-id="element-163" data-mp="2v1krso7d49vr">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-amber text-brand-amber" aria-hidden="true" data-id="element-164" data-mp="2uz81nnrgat7m" />)}
              </div>
              <p className="mt-5 flex-1 font-serif text-lg italic leading-relaxed" data-id="element-165" data-mp="34qcfgk5e480v">{quote}</p>
              <div className="mt-6" data-id="element-166" data-mp="2ztc8m70pv18p">
                <p className="text-sm font-bold text-brand-deep" data-id="element-167" data-mp="2zudwjc2tzi7u">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-168" data-mp="2c3hxbtw1pkqk">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}